export default `
<script src="//d2wy8f7a9ursnm.cloudfront.net/v4/bugsnag.min.js"></script>
<script>
  window.bugsnagClient = bugsnag("8729db6e83788a8116b19bca4c594a13");
</script>
`;
